module.exports = __webpack_public_path__ + "img/meter-sell-unit.a0faa7f9.svg";